import { useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import Sidebar from "./Sidebar"

const pageTitles: Record<string, { title: string; subtitle: string }> = {
  "/admin/dashboard":  { title: "Dashboard",   subtitle: "Overview of the tree registry" },
  "/admin/farmers":    { title: "Farmers",      subtitle: "Manage registered farmers" },
  "/admin/map":        { title: "Map View",     subtitle: "Geographic distribution of farms" },
  "/admin/tree-types": { title: "Tree Types",   subtitle: "Manage tree type catalogue" },
}

export default function AdminLayout() {
  const location = useLocation()
  const page = pageTitles[location.pathname] ?? { title: "Admin", subtitle: "" }
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="min-h-screen bg-[#111] flex">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(v => !v)} />

      {/* Main content — offset dynamically */}
      <div
        className="flex-1 flex flex-col min-h-screen transition-all duration-300"
        style={{ marginLeft: collapsed ? "64px" : "224px" }}
      >
        {/* Topbar */}
        <header className="sticky top-0 z-30 bg-[#111]/80 backdrop-blur border-b border-white/[0.06] px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setCollapsed(v => !v)}
              className="text-neutral-500 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <div>
              <h1 className="text-white font-bold text-lg tracking-tight leading-none">
                {page.title}
              </h1>
              {page.subtitle && (
                <p className="text-neutral-500 text-xs mt-1">{page.subtitle}</p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-neutral-600 text-xs">Live</span>
          </div>
        </header>

        <main className="flex-1 px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}